import { useCallback } from 'react';
import { useLazyBindApi } from 'Shared/services/Api';
import { useAxiosErrorReporter } from 'Shared/hooks/useAxiosErrorReporter';
import {
  transformDictionaryResponse,
  DictionaryType,
} from 'QuoteApp/services/endpoints/GetDictionary';

export type DictionaryDataProviderType = {
  dictionaryError: boolean;
  dictionaryLoading: boolean;
  dictionary: DictionaryType | null;
  fetchDictionary(): Promise<DictionaryType | null>;
};

export const useDictionary = (appId: string): DictionaryDataProviderType => {
  const [{ loading, error, data }, fetch] = useLazyBindApi<DictionaryType>({
    method: 'GET',
    url: `/insurance_applications/${appId}/dictionary`,
    transformResponse: transformDictionaryResponse,
  });

  useAxiosErrorReporter({
    name: 'dictionaryError',
    error,
  });

  const fetchDictionary = useCallback(
    async () => (await fetch()).data,
    [fetch]
  );

  return {
    dictionaryLoading: loading,
    dictionaryError: !!error,
    dictionary: data,
    fetchDictionary,
  };
};
